import { User } from "lucide-react";
import Link from "next/link";
import { trackGeneric } from "@/app/lib/tracking/interactions";

const LoginButton = () => {
  return (
    <Link href="/auth/login" aria-label="Giriş Yap" onClick={() => trackGeneric("header_login", "click")} className="flex items-center gap-2 font-medium text-sm hover:text-main transition-all duration-300 ease-in-out">
      <User className="size-6 md:size-4.75" />
      <p className="hidden md:block">Giriş Yap</p>
    </Link>
  );
};

export default LoginButton;
